module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', {
    class: _vm.headerClass
  }, [_c('b-navbar', {
    attrs: {
      "toggleable": "lg",
      "type": "dark"
    }
  }, [_c('b-navbar-brand', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("\r\n                " + _vm._s(_vm.$t('title')) + "\r\n                "), (_vm.isDevelopment) ? _c('b-badge', {
    attrs: {
      "variant": "success"
    }
  }, [_vm._v(_vm._s(_vm.environment))]) : _vm._e()], 1), _vm._v(" "), _c('b-navbar-toggle', {
    attrs: {
      "target": "nav-collapse"
    }
  }), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "is-nav": "",
      "id": "nav-collapse"
    }
  }, [_c('b-navbar-nav', {
    staticClass: "ml-auto"
  }, [_c('b-nav-item-dropdown', {
    attrs: {
      "right": "",
      "text": _vm.$t('message.externalLinks')
    }
  }, _vm._l((_vm.externalLinks), function(site) {
    return (site.name !== '-') ? _c('b-dropdown-item', {
      key: "site",
      attrs: {
        "href": site.link
      }
    }, [_vm._v(_vm._s(site.name))]) : _c('b-dropdown-divider')
  }), 1), _vm._v(" "), _c('b-nav-item', {
    attrs: {
      "href": _vm.documentationPath
    }
  }, [_vm._v(_vm._s(_vm.$t('message.documentation')))]), _vm._v(" "), (!_vm.isAuth) ? _c('b-nav-item', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.login_modal",
      modifiers: {
        "login_modal": true
      }
    }],
    staticClass: "heavier-text",
    attrs: {
      "id": "signin"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.login')))]) : _vm._e(), _vm._v(" "), (_vm.isAuth) ? _c('b-nav-item-dropdown', {
    staticClass: "auth-user-menu",
    attrs: {
      "right": ""
    }
  }, [_c('template', {
    slot: "button-content"
  }, [_c('span', {
    staticClass: "header-username-link"
  }, [_vm._v(_vm._s(_vm.username))])]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "to": "/user-administration/profile"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.profile')))]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('message.signout')))])], 2) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('notification-container'), _vm._v(" "), _c('alert-container'), _vm._v(" "), _c('login')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1f865bd7", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f865bd7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","b-img":"src"}}!./src/components/header/header.html
// module id = 774
// module chunks = 1